import { ReactNode } from 'react';

interface FormFieldProps {
  label: string;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

export function FormField({ label, required = false, children, className = '' }: FormFieldProps) {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-600 dark:text-gray-300 mb-1">
        {label}
        {required && '*'}
      </label>
      {children}
    </div>
  );
}
